var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-table',{attrs:{"flat":"","data":_vm.input,"columns":_vm.columns,"loading":_vm.loading,"pagination":_vm.pagination},on:{"request":function($event){return _vm.$emit('request', $event)}},scopedSlots:_vm._u([{key:"body-cell-action",fn:function(props){return [_c('q-td',{attrs:{"props":props}},[_vm._t("default",null,null,props)],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }